import React, { useRef, useEffect } from "react"

import { ProductPaymentRequestParamsType } from "types"

type Props = {
  uri: string
  method: string
  params: ProductPaymentRequestParamsType
}

const BankLinkForm = ({ uri, method, params }: Props) => {
  const formRef = useRef<HTMLFormElement>(null)

  useEffect(() => {
    if (uri && formRef.current) {
      formRef.current.submit()
    }
  }, [])

  return (
    <form ref={formRef} action={uri} method={method} hidden>
      <input
        id="VK_SERVICE"
        name="VK_SERVICE"
        defaultValue={params.VK_SERVICE}
      />
      <input
        id="VK_VERSION"
        name="VK_VERSION"
        defaultValue={params.VK_VERSION}
      />
      <input id="VK_SND_ID" name="VK_SND_ID" defaultValue={params.VK_SND_ID} />
      <input id="VK_STAMP" name="VK_STAMP" defaultValue={params.VK_STAMP} />
      <input id="VK_AMOUNT" name="VK_AMOUNT" defaultValue={params.VK_AMOUNT} />
      <input id="VK_CURR" name="VK_CURR" defaultValue={params.VK_CURR} />
      <input id="VK_REF" name="VK_REF" defaultValue={params.VK_REF} />
      <input id="VK_MSG" name="VK_MSG" defaultValue={params.VK_MSG} />
      <input id="VK_RETURN" name="VK_RETURN" defaultValue={params.VK_RETURN} />
      <input id="VK_CANCEL" name="VK_CANCEL" defaultValue={params.VK_CANCEL} />
      <input
        id="VK_DATETIME"
        name="VK_DATETIME"
        defaultValue={params.VK_DATETIME}
      />
      <input id="VK_MAC" name="VK_MAC" defaultValue={params.VK_MAC} />
      <input
        id="VK_ENCODING"
        name="VK_ENCODING"
        defaultValue={params.VK_ENCODING}
      />
      <input id="VK_LANG" name="VK_LANG" defaultValue={params.VK_LANG} />
      <button type="submit">Send</button>
    </form>
  )
}

export default BankLinkForm
